import React from "react"
import { Switch, Route, useRouteMatch } from "react-router-dom"

import { LearnLanding } from "./landing"
import { LearnPost } from "./post"

const Learn = () => {
  const { url } = useRouteMatch()

  return (
    <Switch>
      <Route
        path={`${url}/:section?/:path?/:page?`}
        exact
        render={({
          match: {
            params: { section }
          }
        }) => {
          if (section?.includes("post")) {
            return <LearnPost />
          }

          return <LearnLanding />
        }}
      />
    </Switch>
  )
}

export default Learn
